import gql from 'graphql-tag';

export const RISK_LEADS = gql`
  query RiskLeads($total: Int!, $page: Int!, $orderBy: OrderBy, $lookup: String, $userId: String, $status: RiskLeadStatus, $requiresSurvey: Boolean, $riskRatings: [RiskRating!]) {
    riskLeads(total: $total, page: $page, orderBy: $orderBy, lookup: $lookup, userId: $userId, status: $status, requiresSurvey: $requiresSurvey, riskRatings: $riskRatings) {
      total
      items {
        id
        jobId
        jobReference
        jobType
        userId
        user {
          id
          firstName
          lastName
        }
        teamId
        client
        status
        date
        requiresSurvey
        contactRiskRating
        createdAt
        updatedAt
      }
    }
  }
`;

export const RISK_LEAD = gql`
  query RiskLead($id: ID!) {
    riskLead(id: $id) {
      id
      jobId
      jobReference
      jobType
      userId
      user {
        id
        firstName
        lastName
      }
      teamId
      client
      status
      date
      notes
      requiresSurvey
      privateNotes
      contactRiskRating
      createdAt
      updatedAt
    }
  }
`;
